export const SIGN_IN_USER            = 'SIGN_IN_USER';
export const VERIFY_AUTH_USER        = 'VERIFY_AUTH_USER';
export const LOGOUT_USER             = 'LOGOUT_USER';
export const GET_LIST_USERS          = 'GET_LIST_USERS';
export const CHANGE_INPUT_VALUE_USER = 'CHANGE_INPUT_VALUE_USER';
export const SAVE_INFO_USER          = 'SAVE_INFO_USER';
export const GET_INFO_USER           = 'GET_INFO_USER';
export const DELETE_INFO_USER        = 'DELETE_INFO_USER';
export const USER_DEFAULT_DATA       = 'USER_DEFAULT_DATA';
export const CHANGE_INPUT_TYPE       = 'CHANGE_INPUT_TYPE';
export const CHANGE_VALUE_PASSWORD   = 'CHANGE_VALUE_PASSWORD';
export const SAVE_NEW_PASSWORD       = 'SAVE_NEW_PASSWORD';
export const LIST_PERMITS_USER       = 'LIST_PERMITS_USER';
export const CHANGE_STATUS_PERMIT    = 'CHANGE_STATUS_PERMIT';